import { container } from 'inversify-props';
import { AuthenticationService } from '../services/authentication.service';
import { VeterinarianOfficesService } from '../services/veterinarian-offices.service';
import { BaseAPIService } from '../services/base-api.service';
import { VeterinarianOfficeUsersService } from '../services/veterinarian-office-user.service';
import { CustomersService } from '../services/customers.service';
import { AdminUserService } from '../services/admin-user.service';
import { RegisteredTagService } from '../services/registered-tag.service';
import { PaymentsService } from '../services/payments.service';
import { EventLogService } from '../services/event-log.service';
import { ReportService } from '@/services/report.service';

export function containerBuilder(): void {
  // this base service gets injected to all other services that
  // authenticate with our API
  container.addSingleton<BaseAPIService>(BaseAPIService);
  container.addSingleton<AuthenticationService>(AuthenticationService);
  container.addSingleton<VeterinarianOfficesService>(
    VeterinarianOfficesService
  );
  container.addSingleton<VeterinarianOfficeUsersService>(
    VeterinarianOfficeUsersService
  );
  container.addSingleton<CustomersService>(CustomersService);
  container.addSingleton<AdminUserService>(AdminUserService);
  container.addSingleton<RegisteredTagService>(RegisteredTagService);
  container.addSingleton<PaymentsService>(PaymentsService);
  container.addSingleton<EventLogService>(EventLogService);
  container.addSingleton<ReportService>(ReportService);
}
